export default __webpack_public_path__ + "static/media/5.09ac6a83.jpg";